import * as Yup from 'yup';

export const validationSchema = ({ t, lengthAllowed = 0, checkDigitType }) =>
  Yup.object().shape({
    format: Yup.string()
      .nullable()
      .eProFormat(t('Format is invalid'), checkDigitType)
      .eProFormatLength(
        lengthAllowed,
        `${t('Format should have')} ${lengthAllowed} ${t('digits')}`
      )
      .required(t('Format is required')),
    checkDigitTypeId: Yup.string()
      .nullable()
      .required(t('Check Digit Function is required')),
    sequenceStart: Yup.string()
      .nullable()
      .required(t('Lower Bound is required'))
      .integer(t('Lower Bound is invalid'))
      .positive(t('Lower Bound is invalid'))
      .length(
        lengthAllowed,
        `${t('Lower Bound should have')} ${lengthAllowed} ${t('digits')}`
      ),
    sequenceEnd: Yup.string()
      .nullable()
      .required(t('Upper Bound is required'))
      .integer(t('Upper Bound is invalid'))
      .positive(t('Upper Bound is invalid'))
      .length(
        lengthAllowed,
        `${t('Upper Bound should have')} ${lengthAllowed} ${t('digits')}`
      )
  });

export default validationSchema;
